import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './auth.css';
import { getApiBaseUrl } from './uploadUrl';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const base = getApiBaseUrl();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      await axios.post(`${base}/api/authentication/authforgotpassword`, { email });
     setMessage({
        type: 'success',
        text: 'If your email exists, we have sent a reset link/instructions.',
      });

      setTimeout(() => navigate('/reset-password'), 800);
 } catch (err) {
      
      setMessage({
        type: 'success',
        text: 'Reset instructions will be sent if the email is registered.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authPage">
      <div className="authShell" aria-label="Forgot password page">
        <div className="authCard">
          <div className="authCardInner">
            <div className="authBrand">
              <div className="authLogo" aria-hidden="true">
                <Mail size={20} />
              </div>
              <div className="authBrandText">
                <h1>Pranati</h1>
                <p>Reset your password</p>
              </div>
            </div>

            <h2 className="authTitle">Forgot Password</h2>
            <p className="authSubtitle">
              Enter your email address and we will send you instructions to reset your password.
            </p>

            <form className="authForm" onSubmit={handleSubmit}>
              <div>
                <label className="authLabel" htmlFor="forgot-email">
                  Email Address
                </label>
                <div className="authField">
                  <Mail className="authIconLeft" size={18} />
                  <input
                    id="forgot-email"
                    className="authInput"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your.email@company.com"
                    required
                  />
                </div>
              </div>

              {message && (
                <div
                  className={`authAlert ${message.type === 'success' ? 'authAlertSuccess' : 'authAlertError'}`}
                  role="status"
                  aria-live="polite"
                >
                  {message.text}
                </div>
              )}

              <button type="submit" className="authButton" disabled={loading}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>

              <div className="authFooter">
                Remember your password?{' '}
                <Link to="/login" className="authLink">
                  Back to login
                </Link>
              </div>
            </form>
          </div>
        </div>

        <div className="authFinePrint">
          <div>Protected by enterprise-grade security</div>
          <div>© 2026 Pranati. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
}

